import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StandardTableComponent from "../basics/table/StandardTableComponent";
import DeleteModalComponent from "../basics/table/DeleteModalComponent";
import TableDeleteActionComponent from "../basics/table/TableDeleteActionComponent";
import TableEditActionComponent from "../basics/table/TableEditActionComponent";
import Website from "../../models/website/Website";
import WebsiteRepository from "../../repository/WebsiteRepository";
import { ListGroup, Tab } from "react-bootstrap";
import CountryHelper from "../../helpers/CountryHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import ContentBlockRepository from "../../repository/ContentBlockRepository";
import FormToastComponent from "../basics/FormToastComponent";
import GeneralSettingsHelper from "../../helpers/GeneralSettingsHelper";
import { FormattedMessage } from "react-intl";
import moment from 'moment';
import Application from "../../helpers/Application";
import { Link } from "react-router-dom";
import FormattedMessageString from "../basics/FormattedMessageString";
import LoaderComponent from "../basics/layout/LoaderComponent";

class ContentBlockOverviewTableComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: this.props.rows,
            type: this.props.type,
            settings: null,
            website: null,
            isLoading: true,
            toggler: [],
            treeData: [],
            language: Application.tableLanguage()
        };

    }

    componentDidMount() {
        let promises = [
            WebsiteRepository.get(Website.get())
        ];

        Promise.all(promises)
            .then(result => {
                let settings = {};

                let websiteResult = result[0];

                this.setState({
                    isLoading: false,
                    settings: settings,
                    website: websiteResult
                });
            });
    }

    columns(index) {
        return [
            {
                dataField: 'id',
                hidden: true
            },
            {
                dataField: 'name',
                text: <FormattedMessageString id="CMS.ContentBlock.overview.table.name" />,
                sort: true,
                isDummyField: true,
                formatter: (cellContent, row) => {
                    return row.contentBlock.name;
                }
            },
            {
                dataField: 'summary',
                text: <FormattedMessageString id="CMS.ContentBlock.overview.table.description" />,
                sort: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '40%' };
                },
                isDummyField: true,
                formatter: (cellContent, row) => {
                    let content = row.contentBlock.contents[index];
                    if (content !== undefined)
                        return content.summary;
                    else
                        return null;
                }
            },

            {
                dataField: 'updated',
                text: <FormattedMessageString id="CMS.ContentBlock.overview.table.last_updated" />,
                isDummyField: true,
                sort: true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    let contentsA = rowA.contentBlock.contents[index];
                    let contentsB = rowB.contentBlock.contents[index];

                    if (order === 'asc') {
                        return Date.parse(contentsA.updated_at) - Date.parse(contentsB.updated_at)
                    }
                    else if (order === 'desc') {
                        return Date.parse(contentsB.updated_at) - Date.parse(contentsA.updated_at)
                    }
                },
                formatter: (cellContent, row) => {
                    let contents = row.contentBlock.contents[index];
                    if (contents === undefined) return null;
                    return (
                        <div className="updated_by">
                            {moment(contents.updated_at).format('DD/MM/YYYY HH:mm:ss')}
                            {contents.updated_by && (<><br /><span className="small-highlighted-text"><FormattedMessageString id="CMS.Pages.overview.table.updated_by" /> {contents.updated_by}</span></>)}
                        </div>
                    )
                }
            },
            {
                dataField: 'actions',
                isDummyField: true,
                text: <FormattedMessage id="CMS.Table.actions" />,
                hidden: !CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR),
                sort: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '10%' };
                },
                formatter: (cellContent, row) => {
                    let canActivate = row.contentBlock.state_active && CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is();

                    return <div className="actions actions-end">
                        {
                            row.contentBlock.active ?
                                <Link to="#" onClick={(event) => this.toggleActive(event, row)}
                                    className={"active " + (!canActivate ? 'btn-disabled' : '')}><FontAwesomeIcon icon={['fas', 'check']} /></Link>
                                :
                                <Link to="#" onClick={(event) => this.toggleActive(event, row)}
                                    className={"inactive " + (!canActivate ? 'btn-disabled' : '')}><FontAwesomeIcon icon={['far', 'times']} /></Link>
                        }
                        {
                            CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) ?
                                <TableEditActionComponent id={row.contentBlock.id}
                                    custom={row.contentBlock.contents[index] !== undefined ? '/' + row.contentBlock.contents[index].language : '/'} />
                                : null
                        }
                        {
                            (CheckPermissions.role(this.props.user.roles, UserRolesEnum.RESELLER)) ?
                                (!GeneralSettingsHelper.is() ?
                                    <TableDeleteActionComponent row={row} parent={this} /> : null)
                                : null
                        }
                    </div>
                }
            }
        ];
    }

    switch(index) {
        return (
            <div className="toggle-tree" data-toggle="buttons" data-index={index}>
                <button type="button" data-toggle="button" data-view-type={"table"} data-index={index}
                    onClick={this.toggle.bind(this)}
                    disabled={this.state.toggler[index] !== undefined && this.state.toggler[index] === "tree" ? null : 'disabled'}>
                    <FontAwesomeIcon icon={['far', 'th']} />
                </button>
            </div>
        );
    }

    toggleActive(event, _row) {
        event.preventDefault();

        ContentBlockRepository.toggle(_row.contentBlock.id)
            .then(response => {
                let newRows = [...this.state.rows];
                newRows = newRows.map((row) => {
                    if (row.contentBlock.id === _row.contentBlock.id) {
                        let contentBlock = row.contentBlock;
                        contentBlock.active = response;
                        return {
                            ...row,
                            contentBlock: contentBlock
                        }
                    }
                    return row;
                })
                this.setState(curr => ({ ...curr, rows: newRows, reload: true }), () => {
                    this.setState({ reload: false })
                });
            })
            .catch(error => {
                FormToastComponent.errorTrans('CMS.ContentBlock.overview.toggle.failed')
            })
    }

    toggle(event) {
        let target = event.target.closest('button')
        let index = target.attributes['data-index'].value
        let viewType = target.attributes['data-view-type'].value

        this.props.parent.setState({
            reload: true
        }, () => {
            this.props.parent.setState({
                reload: false
            }, () => {
                let toggler = this.state.toggler;
                toggler[index] = viewType
                this.props.parent.table_ref.setState({
                    toggler: toggler,
                    language: this.state.language
                })
            })
        })
    }

    updateData() {
        ContentBlockRepository.all()
            .then(response => {
                this.props.parent.setState({
                    rows: response
                })
            })
    }

    table(index) {
        return (
            <div className={"custom-data-table content-blocks"}>

                <StandardTableComponent keyField="id" data={this.state.rows} columns={this.columns(index)} search={true}
                    title={this.props.title_id} type={this.props.type}
                    subRows={false}
                    sort={{
                        dataField: 'name',
                        order: 'asc'
                    }} />
                <DeleteModalComponent parent={this} />
            </div>
        )
    }

    render() {
        if (this.state.isLoading) return <LoaderComponent />;
        if (this.state.reload) return <LoaderComponent />;

        return (
            <div className="tab-tables">
                <Tab.Container id={"list-group-language-content-blocks"}
                    defaultActiveKey={"#" + (this.state.website.languages[this.state.language] !== undefined ? this.state.website.languages[this.state.language].language : this.state.website.languages[0].language)}>
                    <ListGroup>
                        {
                            this.state.website.languages.map((language, index) => {
                                return (
                                    <ListGroup.Item action href={"#" + language.language} key={index}
                                        onClick={() => this.setState({ language: index }, () => Application.setTableLanguage(index))}>
                                        {CountryHelper.getLanguages().find(({ value }) => value + "" === language.language + "").label}
                                    </ListGroup.Item>
                                )
                            })
                        }
                    </ListGroup>
                    <Tab.Content>
                        {
                            this.state.website.languages.map((language, index) => {

                                return <Tab.Pane eventKey={"#" + language.language} key={index}>
                                    {this.table(index)}
                                </Tab.Pane>

                            })
                        }
                    </Tab.Content>
                </Tab.Container>
            </div>
        );
    }
}

ContentBlockOverviewTableComponent.propTypes = {
    title_id: PropTypes.string.isRequired,
    rows: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    parent: PropTypes.object.isRequired
};

export default ContentBlockOverviewTableComponent;